import * as storeConst from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { makeCall, handleProgramServiceError } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";

export const state = {
  clientBrand: {
    primaryColorValue: "#20a8d8",
    subPathUrl: "",
    webLogoUrl: "",
    clientName: "",
    clientId: ""
  }
};

export const getters = {
  [storeConst.GETTERS_CLIENT_BRAND]: state => {
    return state.clientBrand;
  }
};

export const actions = {
  [storeConst.ACTION_CREATE_CLIENT_BRAND]: ({ commit }, options) => {
    const url = getEndPoints().clientBrand.create;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        if (response && options.successMessage) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },

  [storeConst.ACTION_UPDATE_CLIENT_BRAND]: ({ commit }, options) => {
    const url = getEndPoints().clientBrand.update.replace(":id", options.id);
    makeCall(url, buildOptions("PUT", options.data), commit)
      .then(response => {
        commit(storeConst.MUTATION_SET_CLIENT_BRAND, response);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [storeConst.ACTION_GET_CLIENT_BRAND_BY_CLIENT]: ({ commit }, options) => {
    const url = getEndPoints().clientBrand.getByClient.replace(
      ":clientId",
      options.clientId
    );
    makeCall(url, buildOptions("GET", {}), commit)
      .then(response => {
        commit(storeConst.MUTATION_SET_CLIENT_BRAND, response);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  }
};

export const mutations = {
  [storeConst.MUTATION_SET_CLIENT_BRAND]: (state, payload) => {
    state.clientBrand = payload;
  },
  [storeConst.MUTATION_RESET_CLIENT_BRAND]: state => {
    state.clientBrand = {
      primaryColorValue: "#20a8d8",
      subPathUrl: "",
      webLogoUrl: "",
      clientName: "",
      clientId: ""
    };
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/client_brand/index.js